import { initData } from '@telegram-apps/sdk-react';

/**
 * Хук для определения, содержит ли startParam информацию о принтере.
 *
 * Проверяет начальный параметр Telegram на соответствие формату "printer_ID",
 * где ID может быть "80" или "443", представляющие идентификаторы принтеров.
 *
 * @returns {{isPrinterLink: boolean, printerId: null}} Объект с информацией о принтере
 * @returns {boolean} returns.isPrinterLink - Указывает, относится ли startParam к принтеру
 * @returns {string|null} returns.printerId - ID принтера ("80" или "443"), если найден, иначе null
 */
export function useIsPrinterStartParam() {
  const startParam = initData.startParam();

  if (!startParam) {
    return {
      isPrinterLink: false,
      printerId: null,
    };
  }
  const match = startParam.match(/^printer_(\d+)$/);

  if (match) {
    return {
      isPrinterLink: true,
      printerId: match[1],
    };
  }
  return {
    isPrinterLink: false,
    printerId: null,
  };
}
